import { showWarningNotification } from '../../notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../../notifications/constants';
/**
 * The room is showing a different camera from the one the person chose.
 * Say so rather than switching silently: what the settings say is selected
 * must be what the call uses, and when it cannot be, the person is told
 * which camera is live instead and why.
 *
 * @param {Function} dispatch - Redux dispatch; nothing is shown without one.
 * @param {ICameraSubstitution} substitution - The chosen and the opened camera.
 * @returns {void}
 */
export function notifyCameraSubstituted(dispatch, substitution) {
    if (typeof dispatch !== 'function') {
        return;
    }
    const { obtainedLabel, reason, requestedLabel } = substitution;
    dispatch(showWarningNotification({
        descriptionArguments: {
            obtained: obtainedLabel || 'another camera',
            requested: requestedLabel || 'Your chosen camera'
        },
        descriptionKey: reason === 'busy' ? 'notify.cameraSubstitutedBusy' : 'notify.cameraSubstitutedMissing',
        titleKey: 'notify.cameraSubstitutedTitle',
        uid: 'camera-substituted'
    }, NOTIFICATION_TIMEOUT_TYPE.LONG));
}
/**
 * The page's own dispatch, when a room store exists (web rooms). Returns
 * undefined elsewhere (tests, pages without the app), so callers can pass it
 * through without guarding.
 *
 * @returns {Function|undefined}
 */
export function roomDispatch() {
    return typeof APP !== 'undefined' && APP?.store?.dispatch ? APP.store.dispatch : undefined;
}
